import { be1Fetch } from '../config/api';
import { errorText } from '../services/errorText';

export interface CsvColumn { name: string; dataType: string; sample?: string }
export interface CsvColumnsResult { path: string; columns: CsvColumn[]; sampleRows: number; size: number }

/** SAM파일의 항목 목록 — 서버(SAM_BROWSE_ROOT 기준 상대경로)의 헤더와 앞쪽 행으로 자료형·예시값을 유추 */
export async function fetchCsvColumns(path: string, delimiter = ',', hasHeader = true, encoding = 'UTF-8'): Promise<CsvColumnsResult> {
  const qs = new URLSearchParams({ path, delimiter, has_header: String(hasHeader), encoding });
  const res = await be1Fetch(`/api/fs/csv-columns?${qs.toString()}`);
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { msg = errorText(await res.json(), msg); } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}
